import * as React from "react";

import {
  BROKER_ALERT_CLASS,
  BROKER_ALERT_DESC_CLASS,
  BROKER_ALERT_NOTE_CLASS,
  BROKER_ALERT_TITLE_CLASS,
  BrokerAlertIcon,
} from "@/components/Broker/brokerAlertUi";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

export type MarketDataInstrumentConsentFieldProps = {
  id: string;
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
};

export function MarketDataInstrumentConsentField({
  id,
  label,
  checked,
  onCheckedChange,
  className,
}: MarketDataInstrumentConsentFieldProps): React.ReactElement {
  return (
    <Alert
      variant="info"
      data-market-data-instrument-consent=""
      className={cn(BROKER_ALERT_CLASS, className)}
    >
      <BrokerAlertIcon tone="info" />
      <AlertTitle className={BROKER_ALERT_TITLE_CLASS}>Broker feed consent</AlertTitle>
      <AlertDescription className={cn(BROKER_ALERT_DESC_CLASS, "space-y-3")}>
        <label htmlFor={id} className="flex cursor-pointer items-start gap-3">
          <Checkbox
            id={id}
            data-market-data-consent-checkbox=""
            checked={checked}
            onCheckedChange={(value) => onCheckedChange(value === true)}
            className="mt-0.5 shrink-0"
          />
          <span className="min-w-0 leading-5">{label}</span>
        </label>
        {!checked ? (
          <p className={cn(BROKER_ALERT_NOTE_CLASS, "m-0 not-italic")}>
            Check the box above to enable Confirm.
          </p>
        ) : null}
      </AlertDescription>
    </Alert>
  );
}
